import React from 'react';
import StickyNotificationsView from '../../../Common/Components/StickyNotificationsView.jsx';
import NotFoundView from '../../../Common/Components/NotFoundView.jsx';
import { setupGoogleTagManagerScript } from '../../../Common/Globals/Scripts/GoogleTagManagerSetup';
import { useLocation } from "react-router-dom-v5-compat";
import NotificationActions from "../../../Common/Actions/NotificationActions.js";

export default function AuthsMasterPageView(props) {
    React.useEffect(() => {
        setupGoogleTagManagerScript("unknown");
    }, []);

    const location = useLocation();

    React.useEffect(() => {
        NotificationActions.clearNotifications();
    }, [location])

    return (
        <section className="authsApp notificationsOnly">
            <StickyNotificationsView />
            {
                props.children ?
                    props.children :
                    <NotFoundView />
            }
        </section>
    );
}
